import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateNoteComponent } from '../private-note/create-note.component';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { GmNoteService } from 'src/app/services/gm-note.service';
import { CityEnterDeletemodelComponent } from '../deletemodel/deletemodel.component';

export interface Note {
  id: number;
  text: string;
  position: string; // or [number, number] if you want to parse it
  is_private: boolean;
  created_at: string; // ISO date string
  updated_at: string; // ISO date string
  game: number;
  created_by: number;
}
@Component({
    selector: 'app-note-list',
    templateUrl: './note-list.component.html',
    styleUrls: ['./note-list.component.scss'],
    standalone: false
})
export class NoteListComponent implements OnInit {
  noteType: 'private' | 'public' = 'private'; // Dynamic variable to determine note type
  notes: Note[] = []; // Array to hold notes\
  userId: string | number = '';
  game_id: string | number = '';
  isFilter: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private currentUserService: CurrentUserService,
    private gmNoteService: GmNoteService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // Notes can be passed in when the modal is opened
    // Default to empty array if not provided
    this.setUpCurrentUserSubscription();
  }

  setUpCurrentUserSubscription() {
    this.currentUserService.currentUser.subscribe((user) => {
      if (user) {
        this.userId = parseInt(user.id);
        this.getAllNotes(this.userId);
      }
    
          this.cdr.detectChanges();});
  }

  getAllNotes(userId: string | number) {
    this.gmNoteService.getNotes(userId, this.game_id).subscribe({
      next: (data: any) => {
        if (data.length > 0) {
          this.notes = data;
          if (this.isFilter) {
            this.filterNotesByType(this.noteType);
          }
        } else {
          this.notes = [];
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error fetching notes:', err);
      
          this.cdr.detectChanges();},
    });
  }

  filterNotesByType(type: 'private' | 'public') {
    const isPrivate = type === 'private';
    this.notes = this.notes.filter((note) => note.is_private === isPrivate);
  }
  openCreateNoteModal() {
    const modalRef = this.modalService.open(CreateNoteComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: 'custom-modal-style',
      size: 'lg',
    });

    // Set the note type in the create modal if needed
    if (modalRef.componentInstance) {
      modalRef.componentInstance.noteType = this.noteType;
      modalRef.componentInstance.game_id = this.game_id;
      modalRef.componentInstance.userId = this.userId;
    }

    modalRef.result.then(
      (result) => {
        if (result && result.action === 'created') {
          this.getAllNotes(this.userId);
        }
      
          this.cdr.detectChanges();},
      (reason) => {
        // Modal dismissed
      },
    );
  }

  deleteNote(note: any, index: number) {
    // Remove the note from the list
    const modalRef = this.modalService.open(CityEnterDeletemodelComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.pagename = 'Note';
    modalRef.componentInstance.actionName = 'Note';
    modalRef.componentInstance.id = note.id;
    modalRef.componentInstance.user_id = this.userId;
    modalRef.result.then((result) => {
      this.getAllNotes(this.userId);
    
          this.cdr.detectChanges();});
  }

  closeModal() {
    this.activeModal.close({ action: 'closed', notes: this.notes });
  }
}
